import { useState, useCallback } from 'react';

export function useClipEditing() {
  const [isClipEditModalOpen, setIsClipEditModalOpen] = useState(false);
  const [editingClip, setEditingClip] = useState(null);

  const handleEditClip = useCallback((clip) => {
    setEditingClip(clip);
    setIsClipEditModalOpen(true);
  }, []);

  return { isClipEditModalOpen, setIsClipEditModalOpen, editingClip, handleEditClip };
}